import { ASTGeneratedOutput, Generator } from "@core/services/common/Generator";
import { useOffers } from "../../../../../../stores/admin/offers/offersStore";

export default function offer (offerId: string): ASTGeneratedOutput {
  const { isShowCommissions } = useOffers();
  const money = ["value","currency"];

  const exclude = [];
  if (!isShowCommissions) {
    exclude.push(
      "advertiserMinimalCommission/value",
      "advertiserMinimalCommission/currency",
      "minimalCommission/value",
      "minimalCommission/currency",
      "finance/rate/value",
      "finance/rate/currency",
      "finance/minimalCommission/value",
      "finance/minimalCommission/currency"
    );
  }

  const params = {
    exclude
  };

  const gqlObject = {
    operation: "offer",

    fields: [
      "id",
      "intId",
      "slug",
      "labels",
      "vertical",
      "type",
      "photoUrl",
      "landingUrl",
      "createdAt",
      {
        minimalCommission: money
      },
      {
        advertiserMinimalCommission: money
      },
      {
        detail: [
          "name",
          "description",
          "rules",
          "isInHouse"
        ]
      },
      {
        logo: [
          "id",
          "url"
        ]
      },
      {
        previewLogo: [
          "id",
          "url"
        ]
      },
      {
        landing: [
          "currency",
          "cost",
          "preCost"
        ]
      },
      {
        countries: [
          "name",
          "alpha2",
          "alpha3",
          "id"
        ]
      },
      {
        categories: [
          "name",
          "id"
        ]
      },
      {
        trafficTypes: [
          "name",
          "id"
        ]
      },
      {
        finance: [
          { rate: money },
          { payout: money },
          { minimalCommission: money },
          "withdrawType",
          "subGoalType",
          "duplicateTimeout",
          {
            holdTime: [
              "holdMinutes"
            ]
          },
          "currency"
        ]
      }
    ],

    variables: {
      offerId: {
        type: "Uid!",
        value: offerId
      }
    }
  };

  return Generator.query(gqlObject, params);
}
